import React from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/Controls/InputField/InputField";
import { SelectComponent } from "../../../components/Controls/Select/Select";
import * as actions from "../../../store/appointments/actions";
import { injectIntl } from "react-intl";
import './style.scss';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const appTypes = [
    {id: 0, name: messages.appointments.all_types},
    {id: 2, name: messages.patients.form.video_call},
    {id: 4, name: messages.patients.form.at_office},
    {id: 3, name: messages.patients.form.audio_call},
    {id: 1, name: messages.patients.form.textual_app},
  ]
  const appStatus = [
      {id: 0, name: messages.appointments.all_status},
      {id: 1, name: messages.patients.form.first_app},
      {id: 2, name: messages.patients.form.inquiry_app},
      {id: 3, name: messages.patients.form.explantation_app},
  ]
  const payload = { page: 1, appointmentStatus: 4, sort: "id,desc" };
  const initialValues = {
    search: "",
    appointmentType: 0,
    appointmentPurpose: 0,
  };
  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    appointmentType: Yup.object().nullable(),
    appointmentPurpose: Yup.object().nullable(),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });

  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: e.target.value, appointmentType: formik.values.appointmentType, appointmentPurpose: formik.values.appointmentPurpose });
    dispatch(
      actions?.getMyAppointmentsRequest({
        ...payload,
        appointmentType: formik.values.appointmentType,
        appointmentPurpose: formik.values.appointmentPurpose,
        search: e.target.value,
      })
    );
    // setSearchValues({ ...formik.values });
  };

  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, appointmentType: e.target.value, appointmentPurpose: formik.values.appointmentPurpose });
    dispatch(
      actions?.getMyAppointmentsRequest({
        ...payload,
        ...formik.values,
        appointmentType: e.target.value,
      })
    );
  };
  const searchWithStatus = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, appointmentType: formik.values.appointmentType, appointmentPurpose: e.target.value });
    dispatch(
      actions?.getMyAppointmentsRequest({
        ...payload,
        ...formik.values,
        appointmentPurpose: e.target.value,
      })
    );
  };

  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row">
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.appointments.search}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="appointmentType"
              list={appTypes}
              keyName="name"
              valueKeyName="id"
              value={formik.values.appointmentType}
              handleChange={(e) => searchWithSelect(e, "appointmentType")}
              error={formik.errors.appointmentType}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="appointmentPurpose"
              list={appStatus}
              keyName="name"
              valueKeyName="id"
              value={formik.values.appointmentPurpose}
              handleChange={(e) => searchWithStatus(e, "appointmentPurpose")}
              error={formik.errors.appointmentPurpose}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
